import React from 'react';
import { Save } from 'lucide-react';
import { ButtonV2, ButtonV2Props } from './index';

interface SaveButtonProps extends Omit<ButtonV2Props, 'prefix' | 'children'> {
  showLeftIcon?: boolean;
  buttonText?: string;
}

export const SaveButtonV2: React.FC<SaveButtonProps> = ({ 
  showLeftIcon = true,
  buttonText = 'Save',
  variant = 'primary',
  size = 'sm',
  ...props
}) => {
  return (
    <ButtonV2
      variant={variant}
      size={size}
      prefix={showLeftIcon ? <Save size={14} /> : undefined}
      {...props}
    >
      {buttonText}
    </ButtonV2>
  );
};
